import { styled } from "@glitz/react";
import {
  theme,
  fontSize,
  fontWeight,
  Theme,
  Size,
  size,
  white,
} from "../../theme";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  as?: Theme;
  size?: Size;
  ghost?: boolean;
  fullWidth?: boolean;
}
const BaseButton = styled.button({
  borderRadius: " 5px",
  border: {
    xy: { style: "solid" },
  },
  fontSize: fontSize.m,
  fontWeight: fontWeight.bold,
  cursor: "pointer",
  transitionProperty: "background-color",
  transitionDuration: "0.3s",
  ":disabled": {
    cursor: "not-allowed",
  },
});

const setDecorator = (as: keyof typeof theme, buttonSize: Size) => ({
  backgroundColor: theme[as].backgroundColor,
  border: {
    xy: { color: theme[as].backgroundColor, width: "2px" },
  },
  color: theme[as].color,
  padding: size[buttonSize],
  ":hover": {
    backgroundColor: theme[as].hover,
    border: {
      xy: { color: theme[as].hover, width: "2px" },
    },
  },
});

const setGhostDecorator = (as: keyof typeof theme, buttonSize: Size) => ({
  backgroundColor: white,
  border: {
    xy: { color: theme[as].backgroundColor, width: "2px" },
  },
  color: theme[as].backgroundColor,
  padding: size[buttonSize],
  ":hover": {
    border: { xy: { color: theme[as].hover, width: "2px" } },
    color: theme[as].hover,
  },
});

const Button: React.FC<ButtonProps> = ({
  as = Theme.Primary,
  size = Size.Medium,
  ghost = false,
  fullWidth = false,
  ...props
}) => {
  const decorator = ghost
    ? setGhostDecorator(as, size)
    : setDecorator(as, size);

  // Om fullWidth är true, lägg till width: '100%' i css
  if (fullWidth) {
    Object.assign(decorator, { width: "100%" });
  }

  return <BaseButton {...props} css={decorator} />;
};

export default Button;
